import bind from 'ramda/es/bind';
import map from 'ramda/es/map';
import Route from 'route-parser';

// react-router doesn't provide reverse functionality, and our router setup
// makes it very difficult to use react-router-reverse, so I'm using route-parser
// Unfortunately, that uses a slightly different format than react-router so
// we can't generate this from our routes object very easily.
const routes = {
  donate: new Route('/donera/:fundraiserId'),
  donationConfirmation: new Route('/donera/:donationId/tack'),
};

export const reverseRoutes = map((route) => bind(route.reverse, route), routes);
export const reverseRoutesFullpath = map(
  (reverseRoute) => (...args) => {
    return process.env.REACT_APP_HLF_SUCCESS_URL + reverseRoute(...args);
  },
  reverseRoutes
);
